module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGfcc2d8c3ac5a2e301e5bff2331c0665b.fcc2d8c3.png";